import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ValidatorsService } from '@services/util/validators.service';
import { Colaborador } from '@/store/catalogos/colaborador';
import { UtilData } from '@/store/util/UtilData';
import { Character } from '@/utils/characters.interface';
import { Util } from '@/utils/util';
import { CatalogoColaboradorService } from '@services/catalogo/catalogoColaborador.service';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-formulario-colaborador',
  templateUrl: './formulario-colaborador.component.html',
  styleUrls: ['./formulario-colaborador.component.css']
})
export class FormularioColaboradorComponent implements OnInit {
  title = "Nuevo Colaborador";
  form: FormGroup;
  sexoList: Character[] = UtilData.sexoList;
  mostrarBoton: boolean = true;

  fotoPreview: string | ArrayBuffer | null = null;
  fotoError: string = '';
  fotoFile: File | null = null;
  constructor(
    private util: Util,
    private datePipe: DatePipe,
    private catalogoService: CatalogoColaboradorService,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<FormularioColaboradorComponent>,
    private validatorsService: ValidatorsService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
    if (data.update) {
      this.title = "Modificar Colaborador";
      this.catalogoService.getFoto(data?.row?.idColaborador).subscribe(base64Img => {
        this.fotoPreview = base64Img;
      });
    }
    if (data.view) {
      this.catalogoService.getFoto(data?.row?.idColaborador).subscribe(base64Img => {
        this.fotoPreview = base64Img;
      });
      this.title = "Vista Colaborador";
    }
  }

  ngOnInit(): void {
    this.buildForm(this.data?.row);
  }

  private buildForm(data: Colaborador): void {
    this.form = new FormGroup({
      idColaborador: new FormControl(data?.idColaborador ?? null),
      nombre: new FormControl(data?.nombre ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      apellidoPaterno: new FormControl(data?.apellidoPaterno ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      apellidoMaterno: new FormControl(data?.apellidoMaterno ?? '', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(50)]
      }),
      fechaNacimiento: new FormControl(this.datePipe.transform(data?.fechaNacimiento, 'yyyy-MM-dd'),
        Validators.required
      ),
      edad: new FormControl(data?.edad ?? null, [Validators.min(1), Validators.max(99)]),
      sexo: new FormControl(data?.sexo ?? '', Validators.required),
      curp: new FormControl(data?.curp ?? '', [Validators.minLength(18), Validators.maxLength(18)]),

      calle: new FormControl(data?.domicilio?.calle ?? ''),
      cp: new FormControl(data?.domicilio?.codigoPostal ?? '', Validators.maxLength(5)),
      ciudad: new FormControl('', Validators.maxLength(25)),
      municipio: new FormControl('', Validators.maxLength(50)),
      numeroExterior: new FormControl('', Validators.maxLength(9)),
      numeroInterior: new FormControl('', Validators.maxLength(9)),

    });

    this.fotoPreview = data?.fotoFile ?? null;

    if (this.data.view) {
      this.form.disable();
      this.mostrarBoton = false;
    }
  }


  isValidField(field: string): boolean {
    return this.form?.controls[field]?.invalid && this.form?.controls[field]?.touched;
  }

  getFieldError(field: string): string {
    return this.validatorsService.getFieldError(this.form, field);
  }

  // enviar(): void {

  //   if (this.form.invalid) {
  //     this.form.markAllAsTouched();
  //     return;
  //   }

  //   const colaborador: Colaborador = this.formToModel();
  //   const request = this.data.insert
  //     ? this.catalogoService.create(colaborador)
  //     : this.catalogoService.update(colaborador);

  //   request.subscribe(response => {
  //     if (response.success) {
  //       this.util.successMessage("Registro guardado con éxito!");
  //       this.dialogRef.close({ data: response });
  //     } else {
  //       const errorMsg = this.util.isEmpty(response.message)
  //         ? "Ocurrió un error al guardar el registro"
  //         : response.message;
  //       this.util.errorMessage(errorMsg);
  //     }
  //   });
  // }

  enviar(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const colaborador: Colaborador = this.formToModel();
    const request = this.data.insert
      ? this.catalogoService.create(colaborador)
      : this.catalogoService.update(colaborador);

    request.subscribe({
      next: (response) => {
        if (!response.success) {
          const errorMsg = this.util.isEmpty(response.message)
            ? "Ocurrió un error al guardar el registro"
            : response.message;
          this.util.errorMessage(errorMsg);
          return;
        }

        // Si hay foto seleccionada, subirla después de guardar el colaborador
        if (this.fotoFile) {
          const idColaborador = response.data?.idColaborador;

          this.catalogoService.uploadFoto(idColaborador, this.fotoFile).subscribe({
            next: () => {
              this.util.successMessage("Registro y foto guardados con éxito!");
              this.dialogRef.close({ data: response });
            },
            error: () => {
              this.util.errorMessage("Registro guardado, pero no se pudo subir la foto.");
              this.dialogRef.close({ data: response });
            }
          });
        } else {
          this.util.successMessage("Registro guardado con éxito!");
          this.dialogRef.close({ data: response });
        }
      },
      error: () => {
        this.util.errorMessage("Error en la operación.");
      }
    });
  }


  private formToModel(): Colaborador {
    const formValues = this.form.getRawValue();

    return {
      idColaborador: formValues.idColaborador ?? '',
      nombre: formValues.nombre ?? '',
      apellidoPaterno: formValues.apellidoPaterno ?? '',
      apellidoMaterno: formValues.apellidoMaterno ?? '',
      fechaNacimiento: formValues.fechaNacimiento ?? '',
      edad: formValues.edad ?? 0,
      sexo: formValues.sexo ?? '',
      curp: formValues.curp ?? '',
      domicilio: {
        calle: formValues.calle ?? '',
        municipio: formValues.municipio ?? '',
        codigoPostal: formValues.cp ?? 0,
        ciudad: formValues.ciudad ?? '',
        numeroExterior: formValues.numeroExterior ?? 0,
        numeroInterior: formValues.numeroInterior ?? 0
      }
    };
  }

  onFotoSeleccionada(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files?.length) return;

    const file = input.files[0];

    if (!file.type.startsWith('image/')) {
      this.fotoError = 'Solo se permiten imágenes.';
      return;
    }

    if (file.size > 1 * 1024 * 1024) { // 1 MB
      this.fotoError = 'La imagen no debe superar 1 MB.';
      return;
    }

    this.fotoError = '';
    this.fotoFile = file;

    const reader = new FileReader();
    reader.onload = () => this.fotoPreview = reader.result;
    reader.readAsDataURL(file);
  }

}
